module.exports = __webpack_public_path__ + "assets/img/product-country2.5ea7a033.png";